import { render, staticRenderFns } from "./RequestScientificConsultation.vue?vue&type=template&id=0a30a6cf&scoped=true"
import script from "./RequestScientificConsultation.vue?vue&type=script&lang=js"
export * from "./RequestScientificConsultation.vue?vue&type=script&lang=js"
import style0 from "./RequestScientificConsultation.vue?vue&type=style&index=0&id=0a30a6cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30a6cf",
  null
  
)

export default component.exports